import React, { useCallback, useMemo } from 'react'

import styles from './VNPinPad.module.scss'
import VNSecureDots from './VNSecureDots'
import VNPinButton from './VNPinButton'
import { ReactComponent as DeleteIcon } from '../../assets/icons/delete.svg'
import { ReactComponent as QrCodeIcon } from '../../assets/icons/qr-code-scan-pin-button.svg'

// pin pad parameters
export const PIN_MIN_LENGTH = 1
export const PIN_MAX_LENGTH = 6

/**
 * VNPinPad - Pin Screen Component for User/Manager Login Pin Entry
 *
 * @param {Object} props - The properties object.
 * @returns {JSX.Element} The rendered component.
 */
const VNPinPad = ({ onSetPin, startScanner, pin = '', pinRef, header = 'Enter Your Passcode' }) => {
  const QrCodeBtn = useMemo(() => <QrCodeIcon className={styles.qrCodeIcon} />, [])
  const DeleteBtn = useMemo(() => <DeleteIcon className={styles.deleteIcon} />, [])

  const onEntry = useCallback(
    (value) => {
      const currentPin = pinRef.current

      if (value === 'backspace') {
        onSetPin(currentPin.slice(0, -1))
        return
      }

      if (value === 'qrcode') {
        startScanner()
        return
      }

      if (currentPin.length === PIN_MAX_LENGTH) return

      onSetPin(currentPin + value)
    },
    [onSetPin, pinRef, startScanner],
  )

  return (
    <>
      <span className={styles.header}>{header}</span>
      <VNSecureDots count={PIN_MAX_LENGTH} subjectSize={pin.length} />
      <div className={styles.pinpad}>
        <VNPinButton onClick={onEntry} value="1" />
        <VNPinButton onClick={onEntry} value="2" />
        <VNPinButton onClick={onEntry} value="3" />
        <VNPinButton onClick={onEntry} value="4" />
        <VNPinButton onClick={onEntry} value="5" />
        <VNPinButton onClick={onEntry} value="6" />
        <VNPinButton onClick={onEntry} value="7" />
        <VNPinButton onClick={onEntry} value="8" />
        <VNPinButton onClick={onEntry} value="9" />
        <VNPinButton onClick={onEntry} value="qrcode" renderChildren>
          {QrCodeBtn}
        </VNPinButton>
        <VNPinButton onClick={onEntry} value="0" className={styles.zeroButton} />
        <VNPinButton onClick={onEntry} value="backspace" renderChildren>
          {DeleteBtn}
        </VNPinButton>
      </div>
    </>
  )
}

export default VNPinPad
